module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-4 col-md-4 col-md-offset-4"
  }, [(!_vm.hasBookieId) ? _c('div', [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveBookie()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bookieId"
    }
  }, [_vm._v("Bookie ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bookieId),
      expression: "bookieId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.bookieId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bookieId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            Save\n          ")])])]) : _vm._e(), _vm._v(" "), (_vm.hasBookieId) ? _c('div', {
    staticClass: "text-center"
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n          Choose Screen\n        ")]), _vm._v(" "), _vm._l((_vm.screens), function(screen) {
    return _c('div', {
      key: screen.id,
      staticStyle: {
        "float": "left"
      }
    }, [_c('div', {
      staticClass: "screen-button text-center"
    }, [_c('button', {
      staticClass: "btn btn-success btn-lg",
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.saveScreen(screen.screenName)
        }
      }
    }, [_vm._v("\n              " + _vm._s(screen.screenName) + "\n            ")])])])
  })], 2) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('h3', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v("\n              Setup Bookie\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1936d04b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 226
// module chunks = 1